import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhTW from './locales/zh-TW'
import en from './locales/en'
import ja from './locales/ja'

Vue.use(VueI18n)

// 從 localStorage 讀取之前保存的語言設定
const getDefaultLocale = () => {
  const savedLanguage = localStorage.getItem('language')
  const localeMap = {
    '繁體中文': 'zh-TW',
    'ENGLISH': 'en',
    '日本語': 'ja'
  }
  return savedLanguage ? (localeMap[savedLanguage] || 'zh-TW') : 'zh-TW'
}

const i18n = new VueI18n({
  locale: getDefaultLocale(), // 預設語言
  fallbackLocale: 'zh-TW', // 找不到翻譯時的備用語言
  messages: {
    'zh-TW': zhTW,
    'en': en,
    'ja': ja
  }
})

export default i18n
